import { Suspense, lazy, useEffect } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ProtectedRoute } from "./wrappers/ProtectedRoute";
import { fetchMenu } from "./hooks/use-FetchMenu";
import { fetchParamsWeb } from "./hooks/use-FetchParams";
import { PageSuccessPayment } from "./pages/payment/PageSuccessPayment";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import BacCheckout from "./pages/other/BacCheckout";
import ShopGridMarcas from "./pages/shop/ShopGridMarcas";
import CheckoutWithoutLogin from "./pages/other/WitoutLogin/CheckoutWithoutLogin";

import Product from "./pages/shop-product/Product";
import { fetchSocialMedia} from "./hooks/use-FetchSocialMedia";
import { fetchSession } from "./hooks/use-FetchSession";

const PageReturnPolicy = lazy(() => import("./pages/other/PageReturnPolicy"));
const PagePrivacyPolicy = lazy(() => import("./pages/other/PagePrivacyPolicy"));
const PagePreguntasFrecuentes = lazy(() =>
  import("./pages/other/PagePreguntasFrecuentes")
);
const PageUbicaciones = lazy(() => import("./pages/other/PageUbicaciones"));

const PageVersion = lazy(() => import("./pages/other/PageVersion"));

// home pages

const HomeFashionTwo = lazy(() => import("./pages/home/HomeFashionTwo"));
// const HomeSelectedCategory = lazy(()=>import("./pages/home/HomeSelectedCategory"));

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));

// other pages
const AboutTc = lazy(() => import("./pages/other/AboutTc"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));
const Cart = lazy(() => import("./pages/other/Cart"));
const PageTerminosYCondiciones = lazy(() =>
  import("./pages/other/PageTerminosYCondiciones")
);
const PaymentPage = lazy(() => import("./pages/payment/PaymentPage"));
const NotFound = lazy(() => import("./pages/other/NotFound"));

export const LoadingIndicator = (
  <div className="flone-preloader-wrapper">
    <div className="flone-preloader center-loader">
      <span></span>
      <span></span>
    </div>
  </div>
);

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSession())
    dispatch(fetchMenu());
    dispatch(fetchParamsWeb());
    dispatch(fetchSocialMedia()); // se llama una sola vez cuando monta el layout
    
  }, [dispatch]);
  const { loading } = useSelector((state) => state.loader);

  
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop>
        {loading && LoadingIndicator}
        <Suspense fallback={LoadingIndicator}>
          <Routes>
            <Route
              path={process.env.PUBLIC_URL + "/"}
              element={<HomeFashionTwo />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/inicio"}
              element={<HomeFashionTwo />}
            />

            {/*Shop pages */}

            <Route
              path={process.env.PUBLIC_URL + "/producto/:slug"}
              element={<Product />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/productos"}
              element={<ShopGridStandard />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/marca/:slug"}
              element={<ShopGridMarcas />}
            />

            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/nosotros"}
              element={<AboutTc />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contacto"}
              element={<Contact />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/mi-cuenta"}
              element={
                <ProtectedRoute>
                  <MyAccount />
                </ProtectedRoute>
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/registrarse"}
              element={<LoginRegister />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/pago"}
              element={<PaymentPage />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/login"}
              element={<LoginRegister />}
            />

            <Route path={process.env.PUBLIC_URL + "/cart"} element={<Cart />} />

            <Route
              path={process.env.PUBLIC_URL + "/checkout"}
              element={<CheckoutWithoutLogin />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/checkout-bac"}
              element={<BacCheckout />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/terminos-y-condiciones"}
              element={<PageTerminosYCondiciones />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/preguntas-frecuentes"}
              element={<PagePreguntasFrecuentes />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/devoluciones"}
              element={<PageReturnPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/politicas-de-devolucion"}
              element={<PageReturnPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/politica-de-privacidad"}
              element={<PagePrivacyPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/ubicaciones"}
              element={<PageUbicaciones />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/tiendas_tc"}
              element={<PageUbicaciones />}
            />
            <Route path="/pago" element={<PageSuccessPayment />} />
            <Route path="/pago-exito" element={<PageSuccessPayment />} />

            <Route path="/version" element={<PageVersion />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
